import { Reference } from "@models/ISchema";
import { FREE_TEXT_MODALITY_CODE } from "@services/constants/references";

export const getAdaptedReference = (reference: Partial<Reference>, isNew = false) => {
  return {
    ...reference,
    isNew,
    customLabel:
      reference?.referenceCategory?.code === FREE_TEXT_MODALITY_CODE
        ? reference?.value
        : `${reference?.referenceCategory?.code}: ${reference?.value}`,
  };
};

export const getAdaptedReferences = (references: Partial<Reference>[]) => {
  return references?.map(reference => getAdaptedReference(reference));
};
